export default __webpack_public_path__ + "static/media/Shelley_Kloba.aa49330e.jpg";